@for (chip of chips; track chip.raw) {
  <span class="lt-chip" [class.lt-chip-at]="chip.isNamed">
    <span class="lt-chip-label">{{ chip.label }}</span>
    <span class="lt-chip-actions" (click)="$event.stopPropagation()">
      <button
        type="button"
        class="lt-chip-action"
        [class.is-done]="chip.copied"
        (click)="copy(chip, $event)"
        [attr.aria-label]="'Copy ' + chip.bare"
        title="Copy"
      >
        @if (chip.copied) {
          <svg viewBox="0 0 16 16" aria-hidden="true" fill="none" stroke="currentColor"
               stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3.5 8.5 7 12l5.5-7"/>
          </svg>
        } @else {
          <svg viewBox="0 0 16 16" aria-hidden="true" fill="none" stroke="currentColor"
               stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round">
            <rect x="5.5" y="5.5" width="8" height="8" rx="1.3"/>
            <path d="M10.5 5.5V3.3A1.3 1.3 0 0 0 9.2 2H3.3A1.3 1.3 0 0 0 2 3.3v5.9A1.3 1.3 0 0 0 3.3 10.5h2.2"/>
          </svg>
        }
      </button>
      <button
        type="button"
        class="lt-chip-action"
        (click)="filter(chip, $event)"
        [attr.aria-label]="'Filter by ' + chip.bare"
        title="Filter"
      >
        <svg viewBox="0 0 16 16" aria-hidden="true" fill="none" stroke="currentColor"
             stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round">
          <path d="M2 3.5h12l-4.6 5.4v3.6l-2.8 1.4V8.9z"/>
        </svg>
      </button>
    </span>
  </span>
}
